import { useCallback, useMemo, useState } from 'react'
import { CostLock } from './costLock'

/**
 * Holds the cost password in memory for as long as this page is open.
 *
 * Deliberately not `localStorage` and not a token: surviving a refresh is
 * exactly the property a step-up check should NOT have. Closing the tab
 * relocks it, which is the whole point of asking in the first place.
 */
export function CostLockProvider({ children }) {
  const [password, setPassword] = useState(null)

  const unlock = useCallback((value) => setPassword(value || null), [])
  const lock = useCallback(() => setPassword(null), [])

  const value = useMemo(
    () => ({ password, unlocked: !!password, unlock, lock }),
    [password, unlock, lock],
  )
  return <CostLock.Provider value={value}>{children}</CostLock.Provider>
}
